var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "#67678B",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-425 -359) translate(404 307) translate(21 52)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 4.688,
    r: 4.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.938C3.567 9.941.38 13.128.375 17.061c0 .208.168.375.375.375h13.5c.207 0 .375-.167.375-.375-.005-3.933-3.192-7.12-7.125-7.125z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a356b984752b30fc2b9c3b3ed36391c6.svg";
export { ForwardRef as ReactComponent };